import { getThemeData } from '@hzero-front-ui/core';
import { css } from 'styled-components';

// 覆盖鲸海蓝色彩、字体大小样式
var getTreeStyle = function getTreeStyle(props) {
  var _getThemeData = getThemeData(props, 'tree'),
    fontSize = _getThemeData.fontSize,
    iconSize = _getThemeData.iconSize,
    disabledBorderColor = _getThemeData.disabledBorderColor,
    disabledColor = _getThemeData.disabledColor;
  var _getThemeData2 = getThemeData(props, 'common'),
    primary = _getThemeData2.primary,
    primary1 = _getThemeData2.primary1,
    primary2 = _getThemeData2.primary2,
    darkFontColor = _getThemeData2.darkFontColor,
    lineColor1 = _getThemeData2.lineColor1;
  return css([".c7n-tree.c7n-tree{.c7n-tree-checkbox{.c7n-tree-checkbox-inner{border:0.01rem solid ", ";}&.c7n-tree-checkbox-checked{.c7n-tree-checkbox-inner:after{margin-top:1px;margin-left:1px;}}}font-size:", "px;i{font-size:", "px;}.c7n-tree-node-content-wrapper.c7n-tree-node-selected{background-color:", ";}.c7n-tree-node-content-wrapper:hover{background-color:", ";}.c7n-tree-checkbox-checked,.c7n-tree-checkbox-indeterminate{.c7n-tree-checkbox-inner{background-color:", ";border-color:", ";}}.c7n-tree-checkbox-disabled{.c7n-tree-checkbox-inner{background-color:", ";border-color:", " !important;}}.c7n-tree-node-content-wrapper{width:100%;}.c7n-tree-list{.c7n-tree-list-holder-inner{.drag-over{.c7n-tree-node-content-wrapper{background:", " !important;color:", ";.c7n-tree-title{color:inherit;}}}}}.c7n-tree-treenode{.c7n-tree-drop-indicator{background-color:", ";}}}"], lineColor1, fontSize, iconSize, primary2, primary1, primary, primary, disabledColor, disabledBorderColor, primary, darkFontColor, primary);
};
var treeData = {
  name: 'tree',
  data: [{
    fontSize: 12,
    iconSize: 18,
    // 禁用
    disabledColor: '#f5f5f5',
    disabledBorderColor: '#e0e0e0'
  }],
  // 不使用主题5模板，只需要在鲸海蓝基础上修改颜色即可
  onlyTemplate: {
    base: getTreeStyle
  }
};
export default treeData;